module.exports = __webpack_public_path__ + "static/media/purchase.77694ad1.svg";